export const enum BuildingReviewLandingCssSelectorEnum {
  page = '[data-qs=building-review-landing]',
  writeReviewButton = '[data-qs=write-review]',
}
